import { render, staticRenderFns } from "./printFile.vue?vue&type=template&id=01fe0674&scoped=true"
import script from "./printFile.vue?vue&type=script&lang=js"
export * from "./printFile.vue?vue&type=script&lang=js"
import style0 from "./printFile.vue?vue&type=style&index=0&id=01fe0674&prod&lang=css"
import style1 from "./printFile.vue?vue&type=style&index=1&id=01fe0674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe0674",
  null
  
)

export default component.exports